export class MaintenanceDestinatario {
    public id: number;
    public codDealer: string;
    public nombreDealer: string;
    public duns: string;
    public dlDomicilio: string;
    public dlCiudad: string;
    public dlCodPcia: string;
    public dlDescPcia: string;
    public dlCodPostal: string;
    public dlPais: string;
    public nroIibb: string;
    public nroCuit: string;
    public observaciones: string;
    public email:string;
    public tipoDocAfip: string;
    public condicionIva: string;

    public estado: boolean;
    public usrCreacion: string = "";
    public fecCreacion: Date = new Date();
    public usrModif: string | undefined;
    public fecModif: Date | undefined;
    public isActiveRelation: boolean;
    public isSave: boolean;
    public isEdit: boolean;
    public isAdd: boolean;
    public originalData: MaintenanceDestinatario;


    static transformDestinatario(data: any): MaintenanceDestinatario {
        let destinatario = new MaintenanceDestinatario();
        destinatario.id = data.id;
        destinatario.codDealer = data.codDealer;
        destinatario.nombreDealer = data.nombreDealer;
        destinatario.duns = data.duns;
        destinatario.dlDomicilio = data.dlDomicilio;
        destinatario.dlCiudad = data.dlCiudad;
        destinatario.dlCodPcia = data.dlCodPcia;
        destinatario.dlDescPcia = data.dlDescPcia;
        destinatario.dlCodPostal = data.dlCodPostal;
        destinatario.dlPais = data.dlPais;
        destinatario.nroIibb = data.nroIibb;
        destinatario.nroCuit = data.nroCuit;
        destinatario.observaciones = data.observaciones;
        destinatario.email = data.email;
        destinatario.tipoDocAfip = data.tipoDocAfip;
        destinatario.condicionIva = data.condicionIva



        destinatario.estado = data.estado;
        destinatario.usrCreacion = data.usrCreacion;
        destinatario.fecCreacion = new Date(data.fecCreacion);

        if (data.usrModif != undefined && data.usrModif != null) {
            destinatario.usrModif = data.usrModif;
        }

        if (data.fecModif != undefined && data.fecModif != null) {
          destinatario.fecModif = new Date(data.fecModif);
      }

        return destinatario;
      }

      public get tipoDocAfipFilter() {
        switch (this.tipoDocAfip) {
          case '80': return 'CUIT(80)';
          case '86': return 'CUIL(86)';
          case '96': return 'DNI(96)';
          default: return '';
        }
      }

    }
